import { call, put, takeLatest, all } from 'redux-saga/effects';
import { stopSubmit } from 'redux-form';

import * as loginStore from './store';
import AuthService from 'core/utils/auth/auth-service';
import history from 'core/utils/history';

export function* login(action) {
  try {
    yield call(AuthService.login, action.payload)
    history.replace('/');
  } catch(err) {
    yield put(stopSubmit('login', {_error: err}))
  }
}

function* watchLogin() {
  yield takeLatest(loginStore.ActionTypes.login, login)
}

export default function* loginSaga() {
  yield all([
    watchLogin(),
  ]);
}



// WEBPACK FOOTER //
// ./src/components/layouts/login/saga.js